<template>
  <div id="home" class="zweigi">
    <div id="head">
      <div id="spacer">
      <h1>Quiz</h1>
      <h4>Beta</h4>
      </div>
    </div>
    <v-divider></v-divider>
    <h3>Empfehlungen</h3>
    <div v-for="post in posts" :key="post.slug">
      <v-card :to="'/' + post.slug">
          <v-card-title class="title">
              <h5 class="tit">{{ post.title }}</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1">{{ post.summary }}</p>
          </v-card-text>
      </v-card>
      <v-divider></v-divider>
    </div>
    <v-card href="https://lernzettel.org" color="#e67e22" target="_blank">
        <v-card-title class="title">
              <h5 class="tit">lernzettel.org</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1">Plattform für Lernzettel, Präsentationen und Hausarbeiten.</p>
          </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card href="https://zweig.lernzettel.org" color="#2ecc71" target="_blank">
        <v-card-title class="title">
              <h5 class="tit">Stefan Zweig</h5>
          </v-card-title>
          <v-card-text class="text">
              <p class="body-1">Gesammelte Werke</p>
          </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <div class="columns d-print-none">
      <div class="column">
        <v-card href="https://lernzettel.org/impressum">
          <v-card-title class="ma-0 subtitle-1 pe">Impressum</v-card-title>
        </v-card>
      </div>
      <div class="column">
        <v-card href="https://lernzettel.org/datenschutzerklarung">
          <v-card-title class="ma-0 subtitle-1 pe">Datenschutzerklärung</v-card-title>
        </v-card>
      </div>
    </div>
  </div>
</template>

<style scoped>
#head{
    background-color: #2c3e50;
    text-align: center;
}
#spacer > h1, #spacer > h4{
    color: #ecf0f1;
}
#head{
    border-radius: 5px;
}
#spacer{
    padding: 20px;
}
a {
  text-decoration: none; /* no underline */
}
.title{
    padding-bottom: 0px;
}
.text{
    padding-top: 0px;
}
.tit{
    margin: 0px 0px 0px;
}
.blackx{
  color: black;
}
.pe{
  padding-bottom: 16px;
}
</style>

<script>
  export default {
    name: 'home',
    data: () => ({
      posts: [
        {slug: "corona", title: "Coronavirus", summary: "Quiz zum Coronavirus"}
      ]
    }),
    mounted(){
      this.$Progress.finish()
    },
    metaInfo: {
      meta: [
          {
            name: 'description',
            content: 'Lernzettel - Quiz'
          }
        ]
    }
  }
</script>